




















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {State} from 'vuex-class';
import {Grid} from '@toast-ui/vue-grid';
@Component({
  components: {}
})
export default class PageContentBottom extends Vue {
  @State private view!: object;

  @State private onGnb!: boolean;
  @Watch('onGnb')
  onGnbChanged() {
    const grid = this.$refs.tuiGridTop as Grid;
    if (grid) {
      grid.invoke('refreshLayout');
    }
  }
  private itemInfo = {
    name: 'usage_summary'
  };
  private options = {
    header: {
      height: 33
    },
    columnOptions: {
      minWidth: 50
    },
    autoHeigth: true,
    minRowHeight: 31,
    rowHeight: 31,
    minBodyHeight: 31,
    isInitialRequest: true,
    useClientSort: false,

    pageOptions: {
      perPage: 1,
      page: 1,
      totalCount: 1
    }
  };
  private myLang = {
    name: 'ko',
    value: {
      display: {
        noData: `${window.$t('ACCUMULATION_MAIN_NO_DATA_2')}`
      }
    }
  };
  @Prop({required: false, default: false}) smllGridClass?: boolean;
  @Prop({required: true}) private theTitle!: string;
  @Prop({required: true}) private gridProps!: object;
  @Prop({required: true}) private data!: [];
  @Watch('data')
  onDataChanged() {
    const grid: any = this.$refs.tuiGridTop as Grid;
    grid.invoke('resetData', this.data as any);
    grid.invoke('setBodyHeight', this.data.length != 0 ? 190 : 190);
    this.$nextTick(() => {
      grid.invoke('refreshLayout');
    });
  }
  private mounted() {
    var pagination = (this.$refs.tuiGridTop as Grid).invoke('getPagination');
    if (pagination != null) {
      pagination.on('beforeMove', () => {
        this.$emit('searchBtnClick');
      });

      pagination.on('afterMove', () => {
        this.$emit('searchBtnClick');
      });
    }
  }
}
